export default {
  titulo: {
    salones: "Salones",
    salon: "Salón",
    salonArticulo: "El salón",
    salonesArticulo: "Los salones",

    cursos: "Cursos",
    curso: "CURSO",
    cursoArticulo: "El curso",
    cursosArticulo: "Los cursos",

    seccion: "Sección",
    sesionAprendizaje: "Sesión de aprendizaje",
    sesionesAprendizajes: "Sesiones de aprendizajes",
    sesionAprendizajeArticulo: "La Sesión de aprendizaje",
    sesionesAprendizajesArticulo: "Las Sesiones de aprendizajes",

    director: "Director",
    directores: "Directores",
    directorArticulo: "El director",
    directoresArticulo: "Los directores",

    colegio: "colegio",
    colegios: "Colegios",
    colegioArticulo: "COLEGIO",
    colegiosArticulo: "Los Colegios",

    progDocente: "Programación docente",
    progDocentes: "Programaciones docente",
    progDocenteArticulo: "La programación docente",
    progDocentesArticulo: " Las programaciones docentes",

    codigoNivelGrado: "Código modular",
    codigoArea: "Codificación SIAGIE",
  },

  ubicacion: {
    pais: "País",
    ubicacion1: "Departamento",
    ubicacion2: "Provincia",
    ubicacion3: "Distrito",
  },

  modulos: {
    3: "INICIO",
    4: "MÁNAGER",
    5: "CONFIGURACIÓN DEL SISTEMA",
    6: "ADMINISTRACIÓN DEL COLEGIO",
    7: "ACADÉMICO",
    8: "EVALUACIÓN",
    9: "RECURSOS DIGITALES",
    10: "CONDUCTA",
    11: "TESORERÍA",
    12: "MÉTRICAS DEL COLEGIO",
    13: "REPORTES",
    14:  "HORARIO",
  },

  subModulos: {
    1: "Gestión de colegios",
    2: "Gestión de licencias",
    3: "Listado de usuarios",
    4: "Gestión de niveles y grados",
    5: "Gestión de áreas",
    6: "Mi colegio",
    12: "Año lectivo, niveles, grados, periodos y calendario académico",
    11: "Normativas Ministeriales de los grados",
    // 13: "Niveles y grados",
    14: "Carpeta del estudiante",
    15: "Áreas",
    16: "Cursos",
    17: "Matrícula del estudiante y registro familiar",
    19: "RR. HH.: Registro de personal",
    20: "Perfil webmaster",
    22: "Gestión de contenidos",
    26: "Programación docente",
    27: "Simuladores interactivos",
    28: "Plan Lector",
    29: "Libro virtual / Libro de actividades",
    30: "El Libro Total: Biblioteca latinoamericana y universal",
    31: "Gestión de evaluación",
    32: "Gestión de cursos",
    35: "Gestión de niveles y grados",
    36: "Gestión de áreas",
    37: "Gestión de cursos",
    38: "Secciones",
    39: "Asignación de cursos",
    40: "Asignación temario",
    41: "Admisión",
    42: "Matrícula",
    43: "Gestion de Estudiantes",
    44: "Grupos personalizados",
    45: "Configuración de gestión evaluativa",
    46: "Contenidos Inteligenio",
    47: "Cuadernos de trabajo",
    48: "Estandares y competencias",
    49: "Derechos básicos",
    50: "Anecdótico docente",
    51: "Diagnostico de admisión",
    52: "Diagnostico progesivo",
    53: "Diagnostico docente",
    54: "Videos inteligenio",
    55: "Comunicados",
    56: "Aula virtual",
    57: "Enlaces de interes",
    58: "Buscadores de contenidos",
    59: "Capacitación inteligenio",
    61: "Permisos de perfiles",
    62: "Listado de usuarios",
    63: "Mis clases",
    64: "Gestión de contenidos",
    65: "Permisos administrativos",
    66: "Coordinaciones",
    67: "Supervisión del docente",
    68: "Supervisión de clases",
    69: "Supervisión de clases",
    70: "Supervisión del estudiante",
    71: "Supervisión del estudiante",
    72: "Supervisión del docente",
    73: "Enfoques transversales",
    74: "Competencias, capacidades y desempeños",
    75: "Mis actividades",
    76: "Malla curricular",
    77: "Competencias",
    78: "Clases del estudiante",
    79: "Actividades del estudiante",
    80: "Registro anecdótico",
    81: "Registro anecdótico coordinandor",
    82: "Programación docente",
    83: "Gestión de áreas",
    84: "Gestión de cursos",
    85: "Gestión de niveles y grados",
    86: "Escala evaluativa",
    87: "Google Earth",
    88: "Google Maps",

    89: "Competencias, capacidades y desempeños",
    90: "Formato de reportes",
    91: "Manual de convivencia",
    92: "Gamificación",
    93: "Gamificación estudiante",
    94: "Registro de incidencias conductuales",
    95: "Registros conductuales",
    96: "Programación de evaluación",
    97: "Mis evaluaciones",
    98: "Libreta de notas",
    99: "Migración de datos",

    100: "Mis simuladores", //PERFIL ESTUDIANTE
    101: "Gestion de Simuladores", // PERFIL DOCENTE
    102: "Simulador del estudiante", // PERFIL PADRE
    131: "Buzón de mensajería",
    132: "Pantalla de inicio",
    133: "Configuración de pantalla de inicio",

    141: "Configuración de admisión",
    142: "Relación de postulantes",
    // 143: "Banco de Preguntas",
    143: "Gestion de preguntas", //MANAGER
    145: "Mis compañeros",
    146: "Mis docentes",
    147: "Listado de docentes padre de familia",
    148: "Programar reunión",
    149: "Configuración",
    150: "Asignación",
    151: "Registro",
    152: "Pagos",
    153: "Cierre del año y situación del estudiante",
    154: "Registro de asistencia al colegio",
    252: "Simulador de exámenes",
    // Métricas 
    155: "Métricas generales",
    156: "Métricas del estudiante",
    157: "Métricas del docente",
    158: "Evaluaciones del estudiante",
    159: "Gym virtual",
    //horario
    160: "Configuración del docente",
    161: "Horario automático",
    162: "Horario manual",
    163: "Carga docente",
    164: "Postergación de notas"
  },

  action: {
    delete: "Eliminar",
  },
};
